import { useQuery } from '@tanstack/react-query';

import { TemplateApi } from 'api';
import { TEMPLATE_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useBankTemplate(templateId = '', templateVersion = 'latest') {
  const templateApi = new TemplateApi();
  const { userBankId } = useUser();

  const { data: template, isLoading: isLoadingTemplate } = useQuery({
    enabled: !!userBankId && !!templateId.length,
    queryKey: [TEMPLATE_KEY, userBankId, templateId, templateVersion],
    queryFn: () => templateApi.getBankTemplate(userBankId, templateId, templateVersion)
  });

  return { template, isLoadingTemplate };
}
